import { useEffect, useMemo, useRef, useState } from "react"
import { debounce } from "lib/debounce"
import { useAsync } from "lib/@hooks/useAsync"
import { getColumnState, saveColumnState } from "lib/@components/managed-columns/controller/column-state.api"

export function usePersistedColumnState(key, defaultState) {
    const loadedState = useAsync(loadStateWithKey, undefined, [key])
    const [edits, setEdits] = useState(undefined)
    const editsKey = useRef(key)
    const persist = useMemo(makePersist, [])

    if (editsKey.current !== key) {
        persist.flush()
        editsKey.current = key
        setEdits(undefined)
    }

    useEffect(flushOnUnmount, [persist])

    const freshState = loadedState?.key === key ? loadedState.columnState : undefined
    const value = edits ?? freshState ?? defaultState
    return [value, store]

    async function loadStateWithKey() {
        const columnState = await getColumnState({ key })
        return { key, columnState }
    }

    function store(next) {
        setEdits(next)
        persist(key, next)
    }

    function makePersist() {
        return debounce(saveState, 1000, { maxWait: 5000 })
    }

    function saveState(k, columnState) {
        saveColumnState({ key: k, state: columnState }).catch((e) => {
            console.error("column-state: failed to persist", k, e)
        })
    }

    function flushOnUnmount() {
        return () => persist.flush()
    }
}
